import { BotType } from "@rosette/ts/src/business/game/BotType.js";
import type { RefObject } from "react";
import React from "react";
import { Selector } from "@/components/gamesetup/Selector.js";
import { getBotIcon } from "@/components/icon/getBotIcon.js";
import type { SelectorOption } from "@/components/gamesetup/SelectorOptionElem.js";
import type { LobbyManagerStateResult } from "@/utils/api/useLobbyManagerState.js";

import type { KnownLobbySettings } from "@rosette/ts/src/business/game/KnownLobbySettings.js";


interface DifficultySelectorOptions {
    settings: KnownLobbySettings;
    setSelectedDifficulty: (mode: BotType) => void;
    scrollRef: RefObject<HTMLHeadingElement | null>;
    lobbyManagerState: LobbyManagerStateResult;
}

/**
 * A selector for choosing the computer difficulty.
 */
export function DifficultySelector({
    settings, setSelectedDifficulty, scrollRef, lobbyManagerState,
}: DifficultySelectorOptions) {

    const options: SelectorOption<BotType>[] = [];
    for (const botType of BotType.values()) {
        const disabled = (
            botType.isOnline()
            && !lobbyManagerState.isBotAvailable(botType, settings.getRuleset())
        );

        options.push({
            value: botType,
            name: botType.getName(),
            desc: botType.getDesc(),
            icon: getBotIcon(botType),
            disabled,
        });
    }
    return (
        <Selector
            scrollRef={scrollRef}
            options={options}
            inlineIcon={false}
            selection={settings.getBotType()}
            setSelection={setSelectedDifficulty} />
    );
}
